import React from 'react';
import { translate } from 'translations/i18n';
import { useCurrentUser } from 'javascripts/hooks';
import { hasRoleAccess, ADMIN } from 'helpers/roles';
import PromoModal from 'components/shared/PromoModal';

const DOCUMENT_SIGNING_YOUTUBE_URL = 'https://youtu.be/BkrtF49I1JM';

const SignaturesPromoModal = ({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) => {
  const currentUser = useCurrentUser();
  const isAdmin = hasRoleAccess(currentUser, [ADMIN]);

  return (
    <PromoModal
      onRequestClose={onRequestClose}
      videoUrl={DOCUMENT_SIGNING_YOUTUBE_URL}
      titleText={translate('billing.v2.signaturesPromoModal.signatures')}
      features={[
        translate('billing.v2.signaturesPromoModal.featureOne'),
        translate('billing.v2.signaturesPromoModal.featureTwo'),
        translate('billing.v2.signaturesPromoModal.featureThree'),
      ]}
      upgradeNoticeText={translate(
        'billing.v2.addOn.promoModal.adminOnlyPrompt',
      )}
      showAdminNotice={!isAdmin}
    />
  );
};

export default SignaturesPromoModal;
